module.exports = __webpack_public_path__ + "img/productBg.7ed6ac19.png";